import path from 'path'

function resolve (dir) {
  return path.resolve(__dirname, dir || '')
}

// 坏图默认路径
export const BAD_IAMGE = resolve('static/assets/img/badImage.svg') // 'http://p8vbcokhx.bkt.clouddn.com/badImage.svg'
// 没有图片默认路径
export const NO_IMAGE = resolve('static/assets/img/noImage.svg') // 'http://p8vbcokhx.bkt.clouddn.com/noImage.svg'
// 用户默认头像
export const USER_DEFAULT = resolve('static/assets/img/userDefault.png')
